exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#list-interventions .list-item{margin-bottom:0}div.fi-item{display:flex;flex-direction:row;align-content:space-between;align-items:center;justify-content:center;background-color:#eee;margin-bottom:10px}a.btn.del-fi{width:40px;height:40px;margin-right:20px;background-color:#c31616;text-align:center}a.btn.del-fi i{color:#fff;font-size:2.2rem;text-align:center;left:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-345e666b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/FibsddItem.vue
// module id = 624
// module chunks = 0